var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { staticClass: "root", attrs: { "max-width": "550" } },
    [
      _c(
        "w-card-title",
        [
          _vm._v(" " + _vm._s(_vm.$ct("common.documents")) + " "),
          _c("w-spacer"),
        ],
        1
      ),
      _c("app-aws-files-edit", {
        attrs: {
          files: _vm.contact.AWSDocuments,
          "to-add-files": _vm.contact.UnprocessedFiles,
          "to-remove-files": _vm.contact.toDeleteFiles,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }